export var ListViewType;
(function (ListViewType) {
    ListViewType["BASIC"] = "basic";
    ListViewType["TILES"] = "tiles";
})(ListViewType || (ListViewType = {}));
